var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "0 0 50 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0L30 -1.74846e-06L25 35L40 35L50 0ZM25 -2.18557e-06L5 -3.93402e-06L0 35L15 35L25 -2.18557e-06Z",
    fill: "#CBAEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteRight);
export default __webpack_public_path__ + "static/media/QuoteRight.b1d2bae4f5dc3baa04cbe1d51087f9b4.svg";
export { ForwardRef as ReactComponent };